import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MessageSquare, LogIn } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errText } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      navigate("/inbox");
    } catch (err) {
      setError(errText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen relative flex items-center justify-center overflow-hidden" style={{ background: "var(--cd-cream)" }}>
      <div className="absolute w-24 h-24 rounded-lg rotate-12 top-16 left-24" style={{ background: "var(--cd-pink)" }} />
      <div className="absolute w-16 h-16 rounded-lg -rotate-6 bottom-32 left-40" style={{ background: "var(--cd-green)" }} />
      <div className="absolute w-28 h-28 rounded-lg rotate-6 bottom-20 right-32" style={{ background: "var(--cd-blue)" }} />
      <div className="absolute w-14 h-14 rounded-lg -rotate-12 top-28 right-52" style={{ background: "var(--cd-ochre)" }} />

      <form onSubmit={submit} className="card-tactile card-yellow w-[380px] p-7 relative pop-in" data-testid="login-form">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-11 h-11 rounded-lg flex items-center justify-center border-2 bg-white" style={{ borderColor: "var(--cd-navy)", boxShadow: "2px 2px 0 var(--cd-navy)" }}>
            <MessageSquare size={22} strokeWidth={2.5} />
          </div>
          <div>
            <div className="font-heading font-extrabold text-2xl leading-tight">Connect Desk</div>
            <div className="font-hand text-lg text-amber-800 leading-none">sign in to your artboard</div>
          </div>
        </div>

        <label className="label-upper">Employee ID / Email</label>
        <input data-testid="login-email-input" className="input-tactile mb-4" placeholder="e.g. akshay" value={email} onChange={(e) => setEmail(e.target.value)} required />

        <label className="label-upper">Password</label>
        <input data-testid="login-password-input" className="input-tactile mb-5" type="password" placeholder="••••••••" value={password} onChange={(e) => setPassword(e.target.value)} required />

        {error && <div data-testid="login-error" className="text-sm font-semibold text-red-700 mb-3 bg-red-50 border-2 border-red-200 rounded-lg px-3 py-2">{error}</div>}

        <button data-testid="login-submit-btn" className="btn-navy w-full justify-center py-2.5" disabled={busy}>
          <LogIn size={16} /> {busy ? "Signing in..." : "Sign In"}
        </button>
        <div className="font-hand text-base text-amber-800 text-center mt-4">roles: Admin · Agent — assigned by your admin</div>
      </form>
    </div>
  );
}
